"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const expression_1 = require("../expression");
const node_1 = require("../../node");
class TwingNodeExpressionBinary extends expression_1.TwingNodeExpression {
    constructor(left, right, lineno, columno) {
        let nodes = new Map();
        nodes.set('left', left);
        nodes.set('right', right);
        super(nodes, new Map(), lineno, columno);
        this.type = node_1.TwingNodeType.EXPRESSION_BINARY;
    }
    compile(compiler) {
        compiler
            .raw('(')
            .subcompile(this.getNode('left'))
            .raw(' ');
        this.operator(compiler);
        compiler
            .raw(' ')
            .subcompile(this.getNode('right'))
            .raw(')');
    }
    /**
     *
     * @param {TwingCompiler} compiler
     * @returns {TwingCompiler}
     */
    operator(compiler) {
        return compiler;
    }
}
exports.TwingNodeExpressionBinary = TwingNodeExpressionBinary;
